import { useEffect } from "react";
import { useCreateSeedData } from "../../data/mutations/entryPointMutations";
import { WelcomeModal } from "../../layout/portals/WelcomeModal";
import { useQueryClient } from "@tanstack/react-query";
import { useEntryPoint } from "../../data/queries/entryPointQueries";
import welcomeImage from "../../../src/content/img/welcomeBackground.png";

const WelcomePage = () => {
  const { mutate: createSeedData } = useCreateSeedData();
  const queryClient = useQueryClient();
  useEntryPoint();

  useEffect(() => {
    createSeedData(
      {},
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries(["get-entry-info"]);
        },
        onError: (errors) => {
          console.error("seed data error", errors);
        },
      }
    );
  }, [createSeedData, queryClient]);

  return (
    <div
      className="welcome-page-container"
      style={{ backgroundImage: `url(${welcomeImage})` }}
    >
      <div>
        <WelcomeModal isFirstTime={true} modalOpen={true} />
      </div>
    </div>
  );
};

export default WelcomePage;
